import { DatatableUtil } from '@xengage/gw-portals-util-js';

export default {
    // Platform DatatableUtil functions
    sortNumber: DatatableUtil.sortNumber,
    sortDate: DatatableUtil.sortDate,
    sortString: DatatableUtil.sortString,
    sortCurrency: DatatableUtil.sortCurrency
};
